var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',_vm._l((_vm.data),function(width,i){return _c('col',{key:i,style:(_vm.getWidth(width))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }